import moment from "moment";
import { getLocale } from "../translations";

export function formatTimestamp(timestamp, format) {
  moment.locale(getLocale());

  const jsTimestamp = timestamp * 1000;

  if (format === "iso") {
    return moment(jsTimestamp).toISOString();
  }

  return moment(jsTimestamp).format(format);
}

export function formatDate(date, format) {
  moment.locale(getLocale());
  return moment(date).format(format);
}
